export const camLoadingVariants = {
  initial: {
    backgroundPositionX: '-200%',
  },
  animate: {
    backgroundPositionX: '300%',
    transition: {
      duration: 1.2,
      repeat: Infinity,
      repeatDelay: 0.03,
    },
  },
};

export const camVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.15,
    },
  },
};
